import { maskCnpj } from './maskCnpj';
import { maskCpf } from './maskCpf';
export function maskCpfCnpj(value) {
    const valueWithoutMask = value.replace(/\D/g, '');
    if (valueWithoutMask.length <= 11) {
        return maskCpf(valueWithoutMask, false);
    }
    return maskCnpj(valueWithoutMask);
}
